<template>
  <div ref="chartRef" :style="{ width: width, height: height }"></div>
</template>

<script>
import { ref, onMounted, watch, onBeforeUnmount } from 'vue';
import * as echarts from 'echarts';

export default {
  name: 'TierRedemptionChart',
  props: {
    title: {
      type: String,
      default: '等級 × 核銷率'
    },
    /** [{ tierName, issued, used, redemptionRate }] */
    data: {
      type: Array,
      required: true,
      default: () => []
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '320px'
    }
  },
  setup(props) {
    const chartRef = ref(null);
    let chartInstance = null;

    const getOption = () => {
      const rows = props.data || [];
      const categories = rows.map((r) => r.tierName || '未分級');
      return {
        title: {
          text: props.title,
          left: 'center',
          textStyle: { fontSize: 16, fontWeight: 500, color: '#333' }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'cross' }
        },
        legend: {
          top: 32,
          data: ['發行數', '核銷數', '核銷率']
        },
        grid: {
          left: '3%',
          right: '4%',
          top: 72,
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: categories,
          axisLabel: { interval: 0, rotate: categories.length > 4 ? 30 : 0 }
        },
        yAxis: [
          {
            type: 'value',
            name: '數量',
            position: 'left'
          },
          {
            type: 'value',
            name: '核銷率%',
            position: 'right',
            min: 0,
            max: 100,
            axisLabel: { formatter: '{value}%' }
          }
        ],
        series: [
          {
            name: '發行數',
            type: 'bar',
            data: rows.map((r) => r.issued || 0),
            itemStyle: { color: '#9b59b6' },
            barMaxWidth: 28
          },
          {
            name: '核銷數',
            type: 'bar',
            data: rows.map((r) => r.used || 0),
            itemStyle: { color: '#e67e22' },
            barMaxWidth: 28
          },
          {
            name: '核銷率',
            type: 'line',
            yAxisIndex: 1,
            data: rows.map((r) => r.redemptionRate || 0),
            itemStyle: { color: '#4facfe' },
            lineStyle: { width: 2 }
          }
        ]
      };
    };

    const initChart = () => {
      if (!chartRef.value) return;
      chartInstance = echarts.init(chartRef.value);
      chartInstance.setOption(getOption());
    };

    const updateChart = () => {
      if (!chartInstance) return;
      chartInstance.setOption(getOption(), true);
    };

    const resizeChart = () => {
      if (chartInstance) chartInstance.resize();
    };

    onMounted(() => {
      initChart();
      window.addEventListener('resize', resizeChart);
    });

    watch(() => props.data, () => updateChart(), { deep: true });

    onBeforeUnmount(() => {
      if (chartInstance) {
        chartInstance.dispose();
        chartInstance = null;
      }
      window.removeEventListener('resize', resizeChart);
    });

    return { chartRef };
  }
};
</script>
